export default {"src":"/org/_next/static/media/my-bookings.42311de0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};